import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.serialization.json.JsonObject
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent

internal fun tourStandingStatus(row: JsonObject): String = when {
    row.flag("unknown_handicap") -> "Doplnit koncový HDCP"
    row.flag("tie_pending") -> "Čeká na los"
    !row.flag("eligible") -> "Bez pořadí – chybí disciplína"
    else -> ""
}

@Composable
internal fun TourStandingPlayerDialog(row: JsonObject, onClose: () -> Unit) {
    DisposableEffect(row.text("player_id")) {
        val previous = document.activeElement as? HTMLElement
        val overflow = document.body?.style?.getPropertyValue("overflow").orEmpty()
        document.body?.style?.setProperty("overflow", "hidden")
        val keyListener: (Event) -> Unit = { event ->
            val key = event as? KeyboardEvent
            if (key?.key == "Escape") { key.preventDefault(); onClose() }
            if (key?.key == "Tab") {
                val focusable = document.getElementById("tour-player-dialog")?.querySelectorAll("button, [href], [tabindex='0']")
                val first = focusable?.item(0) as? HTMLElement
                val last = focusable?.item((focusable.length - 1).coerceAtLeast(0)) as? HTMLElement
                if (key.shiftKey && document.activeElement == first) { key.preventDefault(); last?.focus() }
                else if (!key.shiftKey && document.activeElement == last) { key.preventDefault(); first?.focus() }
            }
        }
        window.addEventListener("keydown", keyListener)
        onDispose {
            window.removeEventListener("keydown", keyListener)
            document.body?.style?.setProperty("overflow", overflow)
            previous?.focus()
        }
    }
    LaunchedEffect(row.text("player_id")) { (document.getElementById("tour-player-dialog-close") as? HTMLElement)?.focus() }
    Div(attrs = { classes("modal-backdrop"); onClick { onClose() } }) {
        Div(attrs = {
            classes("match-modal", "tour-player-modal"); id("tour-player-dialog")
            attr("role", "dialog"); attr("aria-modal", "true"); attr("aria-labelledby", "tour-player-dialog-title")
            onClick { it.stopPropagation() }
        }) {
            Div(attrs = { classes("match-modal-header") }) {
                H2(attrs = { id("tour-player-dialog-title") }) { Text(row.text("player_name")) }
                Button(attrs = { id("tour-player-dialog-close"); onClick { onClose() } }) { Text("Zavřít") }
            }
            P { Text("Body: ${row.text("points")} · HDCP skupina: ${row.text("handicap_group").ifBlank { "Nepřiřazen" }} · Součet umístění: ${row.text("placement_sum")}") }
            tourStandingStatus(row).takeIf { it.isNotBlank() }?.let { P { Text(it) } }
            val missing = row.strings("missing_disciplines")
            if (missing.isNotEmpty()) P { Text("Chybí: " + missing.joinToString { tourLabel(it, TOUR_DISCIPLINES) }) }
            Div(attrs = { classes("table-scroll"); tabIndex(0); attr("aria-label", "Rozpis bodů hráče") }) {
                Table(attrs = { attr("aria-label", "Rozpis bodů hráče") }) {
                    Thead { Tr { listOf("Turnaj", "Umístění", "Umístění pro pomocný součet", "Základ × Joker", "Kvalifikační bonus", "Pódium", "Body", "Započítáno").forEach { Th { Text(it) } } } }
                    Tbody { row.objects("results").forEach { r -> Tr {
                        Td { Text(r.text("title")) }; Td { Text(r.text("rank").ifEmpty { "Nedokončil" }) }
                        Td { Text(r.text("base_rank")) }; Td { Text("${r.text("base_points")} × ${r.text("joker_multiplier")}") }
                        Td { Text(r.text("qualification_bonus")) }; Td { Text(r.text("podium_bonus")) }
                        Td { B { Text(r.text("points")) } }; Td { Text(if (r.flag("selected")) "Ano" else "Ne") }
                    } } }
                }
            }
        }
    }
}
